import React, { createContext, useContext, useEffect, useRef } from 'react'

const PageHeaderContext = createContext(null)

/**
 * Используется в Layout для получения/установки кастомного заголовка.
 */
export function usePageHeaderContext() {
  const ctx = useContext(PageHeaderContext)
  return ctx
}

/**
 * Устанавливает кастомный заголовок в top-header (кнопка «Назад», заголовок, действия справа).
 * renderActions — функция () => ReactNode, вызывается при рендере Layout.
 * @param {{
 *   backLink?: string
 *   backLabel?: string
 *   title?: string | null
 *   hideTopHeader?: boolean
 *   renderActions?: () => React.ReactNode
 * }} config
 * @param {React.DependencyList} deps — зависимости, при изменении которых обновляется заголовок
 */
export function usePageHeader(config, deps = []) {
  const { setPageHeader } = usePageHeaderContext() || {}
  const configRef = useRef(config)
  configRef.current = config

  useEffect(() => {
    if (!setPageHeader) return
    setPageHeader(configRef.current)
    return () => setPageHeader(null)
  }, deps)
}

export default PageHeaderContext
